import { graphql } from '@/gql'

export const CreateJobShareMutation = graphql(/* GraphQL */ `
  mutation createJobShare($input: CreateJobShareInput!) {
    createJobShare(input: $input) {
      id
      job {
        isForRecruiters
        ...Shares
      }
    }
  }
`)

export const RemoveJobShareMutation = graphql(/* GraphQL */ `
  mutation removeJobShare($input: RemoveJobShareInput!) {
    removeJobShare(input: $input) {
      id
      job {
        isForRecruiters
        ...Shares
      }
    }
  }
`)
